module.exports = __webpack_public_path__ + "img/good_img.1d5cc7fd.png";